import { WeightGridVO as BaseWeightGridVO, entity, field } from '@wizeoo/akm-compute-lib';
import { TranslatedEmb, WeightGrid} from '@wizeoo/akm-message-lib';
import { TranslatableLabelVO } from '../common/translation/translatable-label.vo';
import { Model } from '../../model/model';


/**
 * VO représentant une grille de poids
 */
@entity('wizeoo.allkeyme.integration.message.WeightGrid', 'BU')
export class WeightGridVO extends BaseWeightGridVO {

  public get model(): Model {
    return this._model as Model;
  }
  public set model(value: Model) {
      this._model = value;
  }
  
  constructor(model: Model, pSource?: WeightGrid) {
    super(model, pSource);
  }

  public get businessUnitCode(): string {
    // code de la BU
    return this.source.businessUnitCode;
  }
  public set businessUnitCode(value: string) {
    this.source.businessUnitCode = value;
  }

  // Id technique
  public get id(): number {
    return this.source.id;
  }
  public set id(value: number) {
    this.source.id = value;
  }

  // UID technique
  public get uid(): string {
    return this.source.uid;
  }
  public set uid(value: string) {
    this.source.uid = value;
  }

  // code domaine (root), technique
  public get domain(): string {
    return this.source.domain;
  }
  public set domain(value: string) {
    this.source.domain = value;
  }

  public get version(): number {
    // technique
    return this.source.version;
  }
  public set version(value: number) {
    this.source.version = value;
  }

  // TODO : détecter les changements sur les sous-collections
  @field('maintenanceFlag') // patch pour s'assurer de la demande de mise à jour sur contenu de steps
  public get maintenanceFlag(): string {
    return this.source.maintenanceFlag;
  }
  public set maintenanceFlag(value: string) {
    this.source.maintenanceFlag = value;
  }


  /**
   * Le code vision
   */
  @field('string')
  public set visionCode(value: string) {
    this.source.visionCode = value;
  }
  public get visionCode(): string {
    return this.source.visionCode;
  }

  /**
   * Le code de la measure
   */
  @field('string')
  public set code(value: string) {
    this.source.code = value;
  }
  public get code(): string {
    return this.source.code;
  }

  @field('TranslatedEmb')
  public set label(value: TranslatedEmb) {
    this.source.label = value;
  }
  public get label(): TranslatedEmb {
    return this.source.label;
  }

  // TODO mapper description, dates


  public get exist(): boolean {
    // l'objet existe en BDD (id)
    return this.id > 0;
  }

  /** Libellé traductible */
  private _labelVO: TranslatableLabelVO;
  public get labelVO(): TranslatableLabelVO {
    if (!this._labelVO) {
      this._labelVO = Model.getInstance().localeEngine.newTranslatableVO(this, 'label');
    }
    return this._labelVO;
  }

  public get trsLabel(): string {
    return Model.getInstance().localeEngine.translate(this.label, this.code);
  }

}
